(function () {
  'use strict';

  function setRoles(wrapper) {
    wrapper.querySelectorAll('div[aria-label]:not([role]), span[aria-label]:not([role])').forEach((el) => {
      const isArrow = /ArrowControlContainer/.test(el.className || '');
      el.setAttribute('role', isArrow ? 'button' : 'group');
    });

    wrapper.querySelectorAll('a[class*="Supplier__Container"]:not([aria-label])').forEach((el) => {
      if (el.innerText.trim()) return;
      let author = el.closest('[class*="ClassicContainer"]');
      author = author && author.querySelector('[class*="AuthorName"]');
      el.setAttribute('aria-label', 'View testimonial -' + (author ? ' ' + author.innerText.trim() : ''));
    });
  }

  function init() {
    document.querySelectorAll('.elfsight-widget-wrapper:not([data-sas-a11y])').forEach((wrapper) => {
      wrapper.setAttribute('data-sas-a11y', '');
      setRoles(wrapper);
      new MutationObserver(() => setRoles(wrapper)).observe(wrapper, { childList: true, subtree: true });
    });
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
